import { client } from '../http';

async function markDailyRoutineAsRead(entityId) {
  const response = await client.post('/api/daily-routine/mark-as-read', { entityIds: [entityId] });
  return response.data;
}

export default {
  markDailyRoutineAsRead,
};
